import {Route} from 'react-router-dom';
import {useTelegramAuth} from '../contexts/TelegramAuthContext';
import TelegramRoute from './TelegramRoute/TelegramRoute';
import QuranAPI from '../pages/QuranAPI/QuranAPI';
import AIReports from '../pages/AIReports/AIReports';
function ReaderQuran(){const {token}=useTelegramAuth();return <QuranAPI accessToken={token}/>;}
function ReaderAI(){const {token}=useTelegramAuth();return <AIReports accessToken={token}/>;}
export const readerRoutes=[<Route key="quran-reader" path="/reader/quran" element={<TelegramRoute><ReaderQuran/></TelegramRoute>}/>,<Route key="ai-reader" path="/reader/ai-reports" element={<TelegramRoute><ReaderAI/></TelegramRoute>}/>];
